import { render, staticRenderFns } from "./checkUpIndividualStatus.vue?vue&type=template&id=56b1fd6f"
import script from "./checkUpIndividualStatus.vue?vue&type=script&lang=js"
export * from "./checkUpIndividualStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56b1fd6f')) {
      api.createRecord('56b1fd6f', component.options)
    } else {
      api.reload('56b1fd6f', component.options)
    }
    module.hot.accept("./checkUpIndividualStatus.vue?vue&type=template&id=56b1fd6f", function () {
      api.rerender('56b1fd6f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/checkUpIndividualStatus.vue"
export default component.exports